module.exports = __webpack_public_path__ + "static/media/trophy.a16ede49.png";